import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppNotification from 'Components/AppNotification/AppNotification.jsx';
import './AnalystListViewNew.scss';
import TextInput from 'Components/forms/text-input/TextInput';
import { connect } from 'react-redux';

class AnalystViewNew extends Component {
  constructor(props) {
    super(props);
    this.handleInput = this.handleInput.bind(this);
  }

  handleInput = (item) => (e) => {
    this.props.onCountChange(item, e.target.value);
  }

  onDragOver = (event, type, selectedData) => {
    const highLightedRegion = document.getElementById(selectedData.userId);
    const floatingTextArea = document.getElementById('floating-panel-text');
    if (type === 'REGION') {
      floatingTextArea.innerHTML = `Assign to ${selectedData.key}`;
    } else {
      floatingTextArea.innerHTML = `Assign to ${selectedData.firstName} ${selectedData.lastName}`;
    }

    if (highLightedRegion) {
      highLightedRegion.style.boxShadow = "0 0 5px 2px #ddd";
    }
    event.preventDefault();
  }

  onDragLeave = (selectedData) => {
    const floatingTextArea = document.getElementById('floating-panel-text');
    floatingTextArea.innerHTML = `Drag over to analyst to assign cases.`;
    const highLightedRegion = document.getElementById(selectedData.userId);
    if (highLightedRegion)
      highLightedRegion.style.boxShadow = "none";
  }

  onDrop = (event, type, selectedData) => {
    const highLightedRegion = document.getElementById(selectedData.userId);
    const floatingTextArea = document.getElementById('floating-panel-text');
    if (type === 'REGION') {
      this.props.action(selectedData, "assignToRegion");
    } else {
      this.props.action(selectedData, "assignToUser");
    }
    if (highLightedRegion) {
      highLightedRegion.style.boxShadow = "none";
      floatingTextArea.innerHTML = `Drag over to analyst to assign cases.`;
    }
    event.preventDefault();
  }

  render() {
    
    const items = this.props.dataList.map((region) => {
      return (
        <li
          className="analyst-card"
          key={region.key}
        >
          <div className="AnalystListViewHeader"
            onDragOver={(e) => this.onDragOver(e, 'REGION', region)}
            onDrop={(e) => this.onDrop(e, 'REGION', region)}
            onDragLeave={() => this.onDragLeave(region)}
          >
            <div className="left-side-header-view">
              {region.key} <AppNotification
                className="app-notification-badge"
                info
                badgeType="info"
              >
                {this.props.groupedAnalysts.find(groupRow=> groupRow.userGroupId === region.userGroupId).assignedCasesCount}
              </AppNotification>
            </div>
            <div className="right-side-header-view">
              {this.props.isChecked ?
                <button className="hollow-button-view" onClick={() => this.props.action(region, "assignToRegion")}> Assign </button> :
                <button className="hollow-button-view-disable" disabled> Assign </button>
              }
            </div>
          </div>

          {region.items.map((item) => {
            const fullName = `${item.firstName} ${item.lastName}`;
            const key = `${region.key}_${item.userId}`;
            return (

              <div className="AnalystListView"
                key={key}
                onDragOver={(e) => this.onDragOver(e, 'ANALYST', item)}
                onDrop={(e) => this.onDrop(e, 'ANALYST', item)}
                onDragLeave={() => this.onDragLeave(item)}

              >
                <div className="listview"
                >
                  <div role="button" className="link-wrapper" id={item.userId}>
                    {this.props.user.parsedPermissions.queue.bulkAssigment && <div className="left-side-listview">
                      {this.props.isChecked === false ? <TextInput
                        name="count"
                        label=""
                        type="text"
                        onChange={this.handleInput(item)}
                        value={`${item.numberOfRecordsToAssign}`}
                        placeholder=""
                      /> : <TextInput
                          name="count"
                          label=""
                          type="text"
                          onChange={this.handleInput(item)}
                          value={`${item.numberOfRecordsToAssign}`}
                          placeholder=""
                          disable='true'
                          extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
                        />}
                    </div>}
                    <div className={`center-listview ${!this.props.user.parsedPermissions.queue.bulkAssigment ? 'extra-left-padding' : ''}`}>
                      <span className="cursor-view" onClick={() => this.props.action(item, "gotoAnalystDrawer", region)}>{fullName}  &nbsp;&nbsp;<AppNotification
                        className="app-notification-badge"
                        info
                        badgeType="info"
                      >
                        {item.assignedCasesCount}
                      </AppNotification>
                      </span>
                    </div>
                    <div className={`right-side-listview ${!this.props.user.parsedPermissions.queue.bulkAssigment ? 'extra-bottom-padding' : ''}`}>
                      {this.props.isChecked ?
                        <button className="hollow-button-view" onClick={() => this.props.action(item, "assignToUser")}> Assign </button> :
                        <button className="hollow-button-view-disable" disabled> Assign </button>
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          })}

        </li>)
    });

    return (
      <ul className="analyst-group-list">

        {items}


      </ul>

    )
  }
}
AnalystViewNew.propTypes = {
  dataList: PropTypes.array.isRequired,
  groupedAnalysts: PropTypes.array.isRequired,
  action: PropTypes.func,
  onCountChange: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

AnalystViewNew.defaultProps = {
  action: () => { },
};

export default connect(mapStateToProps)(AnalystViewNew);
